import { useRunStats } from '@/hooks/useSwr';
import { GetRunsQueryParams } from '@/types/schema';

import {
  FEEDBACK_STATS_SELECT,
  RUN_FACETS_SELECT,
  RUN_STATS_SELECT,
  TOKEN_STATS_SELECT,
} from '../constants';

export const useRunStatsStaggered = (
  debouncedRunsFilter: Partial<GetRunsQueryParams> | null,
  datasetShareToken?: string
) => {
  const { data: stats, isLoading: isStatsLoading } = useRunStats(
    {
      ...debouncedRunsFilter,
      select: RUN_STATS_SELECT,
    },
    {
      datasetShareToken,
    }
  );

  const { data: tokenStats, isLoading: isTokenStatsLoading } = useRunStats(
    { ...debouncedRunsFilter, select: TOKEN_STATS_SELECT },
    {
      datasetShareToken,
    }
  );
  const { data: feedbackStats, isLoading: isFeedbackStatsLoading } =
    useRunStats(
      { ...debouncedRunsFilter, select: FEEDBACK_STATS_SELECT },
      {
        datasetShareToken,
      }
    );

  return {
    stats,
    tokenStats,
    feedbackStats,
    isStatsLoading,
    isTokenStatsLoading,
    isFeedbackStatsLoading,
  };
};

export const useFilterShortcutStats = ({
  sessionId,
  runsFilter,
  datasetShareToken,
}: {
  sessionId: string;
  runsFilter: Partial<GetRunsQueryParams> | null;
  datasetShareToken?: string;
}) => {
  const { data: allStats, isLoading: isAllStatsLoading } = useRunStats(
    {
      session: [sessionId],
      start_time: runsFilter?.start_time,
      end_time: runsFilter?.end_time,
      select: RUN_FACETS_SELECT,
    },
    { datasetShareToken },
    { revalidateOnFocus: false }
  );

  const { data: filteredFacets, isLoading: isFilteredFacetsLoading } =
    useRunStats(
      { ...runsFilter, select: RUN_FACETS_SELECT },
      {
        datasetShareToken,
      }
    );

  return {
    allStats,
    filteredFacets,
    isAllStatsLoading,
    isFilteredFacetsLoading,
  };
};
